import { Link } from 'react-router'
import { useMessages } from '@/features/language/use-language'

export function NotFoundPage() {
  const m = useMessages()

  return (
    <div className="bg-canvas text-ink flex min-h-full flex-col items-center justify-center gap-4 px-5 text-center">
      <p className="text-ink-muted">{m.app.notFound.message}</p>
      <Link
        to="/"
        className="pressable border-ink-muted text-ink rounded-card flex min-h-11 items-center border px-[18px] text-[15px]"
      >
        {m.app.notFound.back}
      </Link>
    </div>
  )
}
